export interface IStyles {
  color: string;
  bg: string;
  border: string;
}

export interface IQueryConfig {
  sortConfig: string[];
  groupConfig: {
    limit: number;
    groupBy: string;
  };
  displayOrder: number;
  columnAliasKey: string;
}

export interface StageProps {
  id: number;
  parentId: number;
  stageName: string;
  stageKey: string;
  styles: IStyles;
  queryConfig: IQueryConfig;
}

export class Stage {
  private readonly _id: number;
  private readonly _parentId: number;
  private readonly _stageName: string;
  private readonly _stageKey: string;
  private readonly _styles: IStyles;
  private readonly _queryConfig: IQueryConfig;

  constructor(props: StageProps) {
    this._id = props.id;
    this._parentId = props.parentId;
    this._stageName = props.stageName;
    this._stageKey = props.stageKey;
    this._styles = props.styles;
    this._queryConfig = props.queryConfig;
  }

  public get id(): number {
    return this._id;
  }

  public get parentId(): number {
    return this._parentId;
  }

  public get stageName(): string {
    return this._stageName;
  }

  public get stageKey(): string {
    return this._stageKey;
  }

  public get styles(): IStyles {
    return this._styles;
  }

  public get queryConfig(): IQueryConfig {
    return this._queryConfig;
  }
}
